import { IJudgmentCancellationInfo } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCancellationInfo';
import { IKnmJudgmentCancellationInfoSelectOption } from '../interfaces/IKnmJudgmentCancellationInfoSelectOption';

export const createJudgmentCancellationInfoSelectOption = (
  erknmJudgmentCancellationInfo: IJudgmentCancellationInfo,
): IKnmJudgmentCancellationInfoSelectOption => ({
  ...erknmJudgmentCancellationInfo,
  label: erknmJudgmentCancellationInfo.name,
  value: erknmJudgmentCancellationInfo.id,
});
